export type ErrorField = "email" | "password" | "confirmPassword" | "name" | "general"

export type ResolvedError = {
    code: ErrorCode
    message: string
    fields: ErrorField[]
}

export enum ErrorCode {
    UNKNOWN = "UNKNOWN",
    PASSWORD_TOO_SHORT = "PASSWORD_TOO_SHORT",
    PASSWORD_MISMATCH = "PASSWORD_MISMATCH",
    PASSWORD_WEAK = "PASSWORD_WEAK",
    EMAIL_INVALID = "EMAIL_INVALID",
    EMAIL_ALREADY_EXISTS = "EMAIL_ALREADY_EXISTS",
    INVALID_CREDENTIALS = "INVALID_CREDENTIALS",
    USER_NOT_FOUND = "USER_NOT_FOUND",
    NETWORK_ERROR = "NETWORK_ERROR",
    RATE_LIMITED = "RATE_LIMITED",
    REQUIRED_FIELD = "REQUIRED_FIELD",
}
